module.exports = __webpack_public_path__ + "static/footer-3-dd55f178bd83bb987f2d2524f54897da.mp4";